import { configs } from '../configs';

export const configService = configs[process.env.REACT_APP_TE_APP_ENV];
